// var blockBtn = document.getElementById("block-desc-btn");
// blockBtn.setAttribute("aria-expanded", "false");
// var blockDescElement = document.getElementById("block-desc");
// if (blockDescElement) {
//   blockDescElement.removeAttribute("open");
//   blockDescElement.style.overflow = "hidden";
// }

// addItem to cart - function
async function addItem(variantId, quantity) {
  const result = await fetch("/cart/add.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
    }),
  });
}

document.querySelectorAll(".collection-spotlight_btn").forEach(function (btn) {
  btn.addEventListener("click", async function (e) {
  e.preventDefault();
  const ep = document.querySelectorAll(".collection-spotlight_product_title");
  let formData = {
    items: [],
  };
  ep.forEach(async function (el) {
    let item = {
      id: el.getAttribute("data-vid"),
      quantity: 1,
    };
    formData.items.push(item);
  });

  const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
        async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent,
              },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: true,
              },
            })
          );
        }
      );
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });
});

(() => {
  let edBenefitOnImages = document.querySelectorAll('.product__media-list-wrapper .product-info-button-container');
  edBenefitOnImages.forEach(function(edBenefitOnImage) {
      edBenefitOnImage.addEventListener('click', function (e) {
          e.stopPropagation();
      });
  });
})();

(() => {
  const edProductListWrapperZoom = document.querySelector('.product__media-list-wrapper');
  if (edProductListWrapperZoom && edProductListWrapperZoom.getAttribute('data-enable-image-zoom') == "true") {

    let lastTap = 0;
    const isDesktop = window.matchMedia('(min-width: 1000px)').matches;
    if (edProductListWrapperZoom.getAttribute('data-enable-image-zoom-click-desktop') == "true") {
      if (isDesktop) {
          edProductListWrapperZoom.addEventListener('dblclick', activateZoom);
      }
    }

    if (edProductListWrapperZoom.getAttribute('data-enable-image-zoom-click-mobile') == "true") {
      if (!isDesktop) {
          edProductListWrapperZoom.addEventListener('touchend', handleTap);
          // edProductListWrapperZoom.addEventListener('click', activateZoom);
      }
    }

    function activateZoom() {
      let edZoomButton = document.querySelector('.product__zoom-button');
      console.log("activateZoom",edZoomButton);
      edZoomButton.setAttribute('aria-expanded', 'true');
    }

    function handleTap(event) {
      const currentTime = new Date().getTime();
      const tapLength = currentTime - lastTap;
      lastTap = currentTime;

      if (tapLength < 300 && tapLength > 0) {
          event.preventDefault();
          activateZoom();
      }
    }
  }
})();

(function() {
  function getGermanTime() {
    // Get current time in German timezone (Europe/Berlin)
    const germanTime = new Date().toLocaleString("en-US", {
      timeZone: "Europe/Berlin",
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    
    // Parse the formatted string to get a Date object
    const [dateStr, timeStr] = germanTime.split(', ');
    const [month, day, year] = dateStr.split('/');
    const [hour, minute, second] = timeStr.split(':');
    
    return {
      year: parseInt(year),
      month: parseInt(month) - 1,
      day: parseInt(day),
      hour: parseInt(hour),
      minute: parseInt(minute),
      second: parseInt(second)
    };
  }
  
  function initCutoffTimers() {
    document.querySelectorAll('.ed-cutoff-timer').forEach(wrapper => {
      // const wrapper = document.getElementById('ed-cutoff-timer-{{ section.id }}-{{ block.id }}');
      const timerElement = wrapper.querySelector('.ed-cutoff-timer__countdown');
      const containerElement = timerElement.closest('.ed-cutoff-timer__content');
      const shippingTextElement = containerElement.querySelector('.ed-cutoff-timer__shipping-text');
      const cutoffTimeStr = containerElement.dataset.cutoffTime;
      
      // Info popup functionality
      
      const infoIcon = wrapper.querySelector('.ed-cutoff-timer__info-icon');
      const infoContent = document.querySelector('.ed-cutoff-timer__content');
      const infoPopup = wrapper.querySelector('.ed-cutoff-timer__info-popup');

      if (infoPopup && (infoIcon || infoContent)) {
        const togglePopup = function(e) {
          e.stopPropagation();
          infoPopup.classList.toggle('active');
        };
        
        if (infoIcon) {
          infoIcon.addEventListener('click', togglePopup);
        }
        
        if (infoContent) {
          infoContent.addEventListener('click', togglePopup);
        }
        
        document.addEventListener('click', function(e) {
          if (!infoPopup.contains(e.target) && 
              (infoIcon && !infoIcon.contains(e.target)) &&
              (infoContent && !infoContent.contains(e.target))) {
            infoPopup.classList.remove('active');
          }
        });
      }
      
      if (!cutoffTimeStr) return;
      
      const [cutoffHour, cutoffMinute] = cutoffTimeStr.split(':').map(Number);
  
      function updateTimer() {
        const germanNow = getGermanTime();
        
        // Create cutoff time for today in German timezone
        let cutoffDate = new Date(germanNow.year, germanNow.month, germanNow.day, cutoffHour, cutoffMinute, 0);
        let isToday = true;
        
        // Current time in minutes since midnight
        const currentMinutes = germanNow.hour * 60 + germanNow.minute;
        const cutoffMinutes = cutoffHour * 60 + cutoffMinute;
        
        // If we've passed today's cutoff, calculate for tomorrow
        if (currentMinutes >= cutoffMinutes) {
          // Calculate time until midnight (24:00) for tomorrow's shipping
          const minutesUntilMidnight = (24 * 60) - currentMinutes;
          const hoursRemaining = Math.floor(minutesUntilMidnight / 60);
          const minutesRemaining = minutesUntilMidnight % 60;
          
          timerElement.querySelector('.ed-cutoff-timer__hours').textContent = hoursRemaining;
          timerElement.querySelector('.ed-cutoff-timer__minutes').textContent = minutesRemaining.toString().padStart(2, '0');
          
          // Update shipping text for tomorrow
          shippingTextElement.textContent = wrapper.getAttribute("data-cutoff-time--text-for-tomorrow");
        } else {
          // Calculate time until cutoff for today's shipping
          const minutesUntilCutoff = cutoffMinutes - currentMinutes;
          const hoursRemaining = Math.floor(minutesUntilCutoff / 60);
          const minutesRemaining = minutesUntilCutoff % 60;
          
          timerElement.querySelector('.ed-cutoff-timer__hours').textContent = hoursRemaining;
          timerElement.querySelector('.ed-cutoff-timer__minutes').textContent = minutesRemaining.toString().padStart(2, '0');
          
          // Update shipping text for today
          shippingTextElement.textContent = wrapper.getAttribute("data-cutoff-time--text-for-today");
        }
      }
      
      // Initial update
      updateTimer();
      
      // Update every minute
      setInterval(updateTimer, 60000);
      
      // Also update every second for the first 5 seconds to ensure quick initial display
      /*
      let quickUpdateCount = 0;
      const quickInterval = setInterval(() => {
        updateTimer();
        quickUpdateCount++;
        if (quickUpdateCount >= 5) {
          clearInterval(quickInterval);
        }
      }, 1000);
      */
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCutoffTimers);
  } else {
    initCutoffTimers();
  }
})();

(() => {
  let edAddToCartButtonText;
  let edStickyAddToCartButtonText;
  let edMainAddToCartButtonClicked = false;

  // Check if .ed-product #AddToCart exists before adding event
  const addToCartButton = document.querySelector('.ed-product.has-atc-good-choice-label #AddToCart');    
  if (addToCartButton) {
      addToCartButton.onclick = function() {
          edMainAddToCartButtonClicked = true;
      };
  }

  // Check if #StickyAddToCart exists before adding event
  const stickyAddToCartButton = document.querySelector('#StickyAddToCart');
  if (stickyAddToCartButton) {
      stickyAddToCartButton.onclick = function() {
          edMainAddToCartButtonClicked = true;
      };
  }

  document.addEventListener('variant:added', function() {
      edAddToCartButtonText = document.querySelector('.ed-product #AddToCart:not([disabled]) .loader-button__text');
      edStickyAddToCartButtonText = document.querySelector('#StickyAddToCart:not([disabled])  .loader-button__text');

      if (edAddToCartButtonText && edMainAddToCartButtonClicked) {
          changeAtcButtonText();
      }
      edMainAddToCartButtonClicked = false;
      setTimeout(resetAtcButtonText, 3500);
  });

  function changeAtcButtonText() {
      const buttonLabelAddToCartSuccessfull = addToCartButton.getAttribute("data-button-content--add_to_cart_successful");
      edAddToCartButtonText.innerText = buttonLabelAddToCartSuccessfull;

      if (edStickyAddToCartButtonText) {
          edStickyAddToCartButtonText.innerText = buttonLabelAddToCartSuccessfull;
      }
  }

  function resetAtcButtonText() {
      const buttonLabelAddToCart = addToCartButton.getAttribute("data-button-content--add_to_cart");
      edAddToCartButtonText = document.querySelector('.ed-product #AddToCart:not([disabled]) .loader-button__text');

      if (edAddToCartButtonText) {
          edAddToCartButtonText.innerText = buttonLabelAddToCart;
      }

      edStickyAddToCartButtonText = document.querySelector('#StickyAddToCart:not([disabled])  .loader-button__text');
      if (edStickyAddToCartButtonText) {
          edStickyAddToCartButtonText.innerText = buttonLabelAddToCart;
      }
  }
})();

// Toggle body class when product-sticky-form becomes visible/hidden
// (replaces :has() selector in custom.css for Shopify CDN minification compatibility)
(function() {
  var el = document.querySelector('product-sticky-form');
  if (!el) return;
  var update = function() { document.body.classList.toggle('has-sticky-form-visible', !el.hidden); };
  new MutationObserver(update).observe(el, { attributes: true, attributeFilter: ['hidden'] });
  update();
})();

// inital open of menu tab - elbdev
document.addEventListener('mobile-nav:open', function(event) {
  const initialOpenTabId = document.querySelector('.mobile-nav').getAttribute("data-initial-open-tab");
  if (!initialOpenTabId) return;

    if (window.innerWidth < 1000) {
        let initialOpenTitleTab = document.querySelector('.mobile-nav .mobile-nav__item[data-level="1"]:nth-child(' + initialOpenTabId + ') .mobile-nav__link');
        let initialOpenTab;

        if (initialOpenTitleTab) {
            initialOpenTab = initialOpenTitleTab.nextElementSibling;
        }

        if (initialOpenTab && initialOpenTitleTab) {
            initialOpenTitleTab.setAttribute('aria-expanded', 'true');
            initialOpenTab.setAttribute('open', '');
        }
    }
});

// Animated marker: replace <em> in image-with-text sections with SVG underline
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.section-image-with-text').forEach(section => {
    section.querySelectorAll('em').forEach(em => {
      const innerHTML = em.innerHTML;
      const newSpan = document.createElement('span');
      newSpan.classList.add('animated-marker-container');

      const textSpan = document.createElement('span');
      textSpan.classList.add('animated-marker');
      textSpan.style.setProperty('--marker-color', '#2c7af3');
      textSpan.innerHTML = `
        ${innerHTML}
        <svg class="svg-marker svg-marker--style1" width="201" height="14" viewBox="0 0 201 14" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M3 10.5732C55.565 6.61382 168.107 -0.117058 197.753 4.63415" stroke="var(--marker-color)" stroke-width="6" stroke-linecap="round"></path>
        </svg>
      `;

      newSpan.appendChild(textSpan);
      em.replaceWith(newSpan);
    });
  });
});
